import { InjectionToken } from '@angular/core';

import { BeamWidth, Placement } from '@shure/shared/angular/data-access/system-api/models';

import { Mxa7xxModel } from './mxa7xx-model';

//just some synonymous words for the datatype: "number", makes it easier to see what the map wants/is
export type HeightDiff = number;
export type LobeAngle = number;

export type LimitsOfAngle = { minAngle: number; maxAngle: number };
export type LimitsOfHeight = { minHeight: number; maxHeight: number };
export type ValueLimits = { limitsAngle: LimitsOfAngle; limitsHeight: LimitsOfHeight };

export type Mxa7xxLookupTableData = {
	angle: number;
	cx: number;
	cy: number;
	rx: number;
	ry: number;
};

export enum DevicePerspective {
	Bottom = 'bottom',
	Top = 'top',
	Side = 'side',
	End = 'end'
}

export enum CoveragePerspectives {
	TopDown = 'top-down',
	Side = 'side'
}

export const PERSPECTIVE_MAP: Record<CoveragePerspectives, Record<Placement, DevicePerspective>> = {
	[CoveragePerspectives.TopDown]: {
		[Placement.Ceiling]: DevicePerspective.Bottom,
		[Placement.Table]: DevicePerspective.Top,
		[Placement.WallHorizontal]: DevicePerspective.Side,
		[Placement.WallVertical]: DevicePerspective.End,
		[Placement.NotConfigured]: DevicePerspective.Side
	},
	[CoveragePerspectives.Side]: {
		[Placement.Ceiling]: DevicePerspective.Side,
		[Placement.Table]: DevicePerspective.Side,
		[Placement.WallHorizontal]: DevicePerspective.Top,
		[Placement.WallVertical]: DevicePerspective.Side,
		[Placement.NotConfigured]: DevicePerspective.Side
	}
};

export type Mxa7xxLookupMap = Map<
	CoveragePerspectives,
	Map<Placement, Map<BeamWidth, Map<HeightDiff, Map<LobeAngle, Mxa7xxLookupTableData>>>>
>;

export interface Mxa7xxLookupTableLoader {
	readonly mxa7xxModel: Mxa7xxModel;
	get lookupMap(): Mxa7xxLookupMap;

	get valueLimits(): ValueLimits;
}

export const MXA7XX_TABLE_LOADER = new InjectionToken<Mxa7xxLookupTableLoader>('MXA7XX-TABLE-LOADER');
